import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { DownloadButton } from "../../components/Core/Button/Button";
import Dropdown from "../../components/Core/Dropdown/Dropdown";
import Flex from "../../components/Layout/Flex";
import Breadcrumbs from "../../components/Shared/Breadcrumbs/Breadcrumbs";
import { CustomersReportBreadcrumbs } from "../../configs/breadcrumbNavigation";
import { buildPoolKeyValues, statusTypes } from "../../configs/Reports.config";
import { KeyValue } from "../../models/KeyValue";
import { useOrganisation } from "../../networking/organisation.hooks";
import { apiStore } from "../../stores/api.store";
import { reportStore } from "../../networking/report.api";

const CustomersReportPage: React.FC = () => {
	const { t } = useTranslation();

	const [pool, setPool] = useState<KeyValue>();
	const [status, setStatus] = useState<KeyValue>();
	const [loading, setLoading] = useState<boolean>();

	const { data: organisation } = useOrganisation();

	const pools = buildPoolKeyValues(organisation?.pools || [], t("ALL"));

	const handlePoolChange = (e: KeyValue) => {
		setPool(e);
	};

	const handleStatusChange = (e: KeyValue) => {
		setStatus(e);
	};

	const onSubmit = async () => {
		let selectedPool!: string;
		let selectedStatus!: boolean;

		if (pool?.key && pool?.key !== "") selectedPool = pool?.key as string;
		if (status?.key && status?.key !== "") selectedStatus = status?.key === "true";

		setLoading(true);
		const url = await reportStore.getCustomersReport(selectedPool, selectedStatus);
		setLoading(false);

		if (url) {
			// https://stackoverflow.com/a/59352848
			const downloadLink = document.createElement("a");
			downloadLink.href = apiStore.apiRoot + url;
			downloadLink.download = apiStore.apiRoot + url;
			downloadLink.click();
		}
	};

	return (
		<div className="p-4 px-6">
			<Breadcrumbs items={CustomersReportBreadcrumbs} />
			<Flex margin="1.5rem 0" maxWidth="800px" alignItems="flex-end">
				<Dropdown<KeyValue, KeyValue>
					value={status}
					getValue={(o) => o}
					onChange={handleStatusChange}
					getOptionLabel={(option) => option.value}
					options={statusTypes()}
					placeholder={"reports.filters.status.placeHolder"}
					label={"reports.filters.status.label"}
					margin="0 1rem 0 0"
				/>
				{pools.length > 0 && (
					<Dropdown<KeyValue, KeyValue>
						value={pool}
						getValue={(o) => o}
						onChange={handlePoolChange}
						getOptionLabel={(option) => option.value}
						options={pools}
						placeholder={"reports.filters.pool.placeHolder"}
						label={"reports.filters.pool.label"}
						margin="0 1rem 0 0"
					/>
				)}
				<DownloadButton width="250px" height="38px" onClick={onSubmit} loading={loading}>
					{t("reports.export")}
				</DownloadButton>
			</Flex>
		</div>
	);
};

export default CustomersReportPage;
